import styled from 'styled-components';

const MileageContainer = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing.S8};
  grid-template-columns: 1fr 104px;
`;

export { MileageContainer };
